import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import axios from 'axios'
import { PulseLoader } from 'react-spinners'
import { Form, Button } from 'react-bootstrap'

import { handleErrorAndGenerateMessage } from '../../../functions/errorHandling'

const ChangePassword = (props) => {
  // REDUX
  const dispatch = useDispatch()
  const currentUser = useSelector(state => state.loginReducer.currentUser)

  // STATE
  const [ saving, setSaving ] = useState(false)
  const [ old_password, setOldPassword ] = useState('')
  const [ new_password, setNewPassword ] = useState('')
  const [ confirm_new_password, setConfirmNewPassword ] = useState('')

  const resetState = () => {
    setSaving(false)
    setOldPassword('')
    setNewPassword('')
    setConfirmNewPassword('')
  }

  const handleSubmitPasswordChange = () => {
    let error = ''

    if (!old_password) {
      error = "Please enter your current password"
    } else if (!new_password || !confirm_new_password) {
      error = "Please enter and confirm a new password"
    } else if (new_password.length < 8 || confirm_new_password.length < 8) {
      error = "Passwords must be at least 8 characters in length"
    } else if (new_password !== confirm_new_password) {
      error = "New passwords do not match"
    }


    if (error) {
      return props.alert.show(error)
    }

    setSaving(true)

    axios({
      method: "PATCH",
      headers: {"Authorization": "JWT " + localStorage.getItem("jwt")},
      url: `${currentUser.url}change_password/`,
      data: {
        username: currentUser.username,
        old_password,
        new_password,
      }
    })
    .then(response => {
      props.alert.show('Your password has been changed', { type: 'success' })
      resetState()
    })
    .catch(error => {
      setSaving(false)
      let errorMessage = 'There was an error updating your password'
      if (error?.response?.status === 401) {
        errorMessage = handleErrorAndGenerateMessage(error, 'updating your password', dispatch)
      }
      const data = error?.response?.data
      if (data?.old_password) {
        errorMessage += `: ${data.old_password.join(' ')}`
      } else if (data?.new_password) {
        errorMessage += `: ${data.new_password.join(' ')}`
      }
      props.alert.show(errorMessage)
    })
  }

  const handleEnterPress = (e) => {
    if (e.key === 'Enter') {
      return handleSubmitPasswordChange()
    }
  }

  return (
    <div>
      <Form onKeyDown={handleEnterPress}>

        <Form.Label>
          Username
        </Form.Label>

        <Form.Control
          name='username'
          value={currentUser ? currentUser.username : 'username'}
          onChange={() => null}
          disabled
        />

        <br/>

        <Form.Label>
          Old password
        </Form.Label>

        <Form.Control
          type='password'
          name='old_password'
          value={old_password}
          onChange={e => setOldPassword(e.target.value)}
        />

        <br/>

        <Form.Label>
          New password
        </Form.Label>

        <Form.Control
          type='password'
          name='new_password'
          value={new_password}
          onChange={e => setNewPassword(e.target.value)}
        />

        <br/>

        <Form.Label>
          Confirm new password
        </Form.Label>

        <Form.Control
          type='password'
          name='confirm_new_password'
          value={confirm_new_password}
          onChange={e => setConfirmNewPassword(e.target.value)}
        />

        <br/>

        <Button
          style={{width: '160px'}}
          onClick={handleSubmitPasswordChange}
        >
          {saving ?
            <PulseLoader
              css={`display: block; margin: 0 auto;`}
              color='white'
            />
            :
            'Change Password'
          }
        </Button>
      </Form>

    </div>
  )
}

export default ChangePassword
